import React, { useEffect, useMemo, useState } from 'react'
import IPInput from '../../../../../components/IPInput'
import { BaseComponentWithContextProps, componentWithContext } from '../../../../../base/customHooks/componentHOC'
import { useCustomReducer } from '../../../../../base/customHooks'
import Table from '../../../../../components/Table'
import Swal from 'sweetalert2'
import { IDealer } from '../models/model'
import { GetDealersApi } from '../services/getDealersApi'
import IPButton from '../../../../../components/IPButton'
import moment from 'moment'

interface IDealerListState {
  dealercode: string
  dealerName: string

}

function Index(props: BaseComponentWithContextProps) {

  const getInitialState = (): IDealerListState => {
    return {
      dealercode: '',
      dealerName: '',
    }
  }
  const intialState = getInitialState()
  const [state, setState] = useCustomReducer<IDealerListState>(intialState)

  const [dealerList, setDealerList] = useState<IDealer[]>([])

  const getDealerList = () => {
    props.showLoading();

    const dealersApi: GetDealersApi = new GetDealersApi({})

    const req = {
      dealerCode: state.dealercode,
      dealerName: state.dealerName
    }
    try {
      dealersApi.getDealers(req).then(res => {
        if (res) {
          setDealerList(res)
        } else {
          setDealerList([])
        }
        props.hideLoading();
      }).catch(err => {
        props.hideLoading();
        Swal.fire({
          icon: 'error',
          title: err?.description || 'Bayi listesi alınırken bir hata oluştu.',
          showConfirmButton: true,
          allowOutsideClick: false,
        });
      })
    } catch (err: any) {
      props.hideLoading();
      Swal.fire({
        icon: 'error',
        title: err?.description || 'Bayi listesi alınırken bir hata oluştu.',
        showConfirmButton: true,
        allowOutsideClick: false,
      });
    }
  };




  const tableColumns = useMemo(
    () => [
      {
        Header: '#',
        accessor: 'order',
      },
      {
        Header: 'ID',
        accessor: 'ID',
      },
      {
        Header: 'Açıklama',
        accessor: 'The_Code',
      },
      {
        Header: 'Sap Kodu',
        accessor: 'SAPCode',
      },
      {
        Header: 'Bayi Adı',
        accessor: 'TheName',
      },
      {
        Header: 'Kısa Ad',
        accessor: 'ShortName',
      },
      {
        Header: 'ÖdemeKodu',
        accessor: 'PayMethodCode',
      },
      {
        Header: 'ÖdemeYöntemi',
        accessor: 'PayMethodExp',
      },
      {
        Header: 'Adres1',
        accessor: 'Adress1',
      },

      {
        Header: 'Adres2',
        accessor: 'Adress2',
      },
      {
        Header: 'İlçe',
        accessor: 'District',
      },
      {
        Header: 'İl',
        accessor: 'Province',
      },
      {
        Header: 'Ülke',
        accessor: 'Country',
      },
      {
        Header: 'PostaKodu',
        accessor: 'ZipCode',
      },
      {
        Header: 'Telefon',
        accessor: 'Phone',
      },
      {
        Header: 'Mail',
        accessor: 'Mail',
      },
      {
        Header: 'Oluşturulma',
        accessor: 'CreatedDate',
      },
      {
        Header: 'Güncelleme',
        accessor: 'UpdatedDate',
      },
      {
        Header: 'Silindi',
        accessor: 'Deleted',
      },
      {
        Header: 'Vergi-TC',
        accessor: 'TaxNumber',
      },
      {
        Header: 'Vergi Dairesi',
        accessor: 'TaxeName',
      },
      {
        Header: 'Adres No',
        accessor: 'Addrnumber',
      },
      {
        Header: 'Aktif',
        accessor: 'İsActive',
      },
    ],
    []
  )


  const tableData = useMemo(
    () =>
      dealerList.map((item, index) => {
        const data = {
          order: index + 1,
          ID: item.Id,
          DealerDescription: item.DealerDescription,
          The_Code: item.TheCode,
          SAPCode: item.Sapcode,
          TheName: item.TheName,
          ShortName: item.ShortName,
          PayMethodCode: item.PayMethodCode,
          PayMethodExp: item.PayMethodExp,
          Adress1: item.Adress1,
          Adress2: item.Adress2,
          District: item.District,
          Province: item.Province,
          Phone: item.Phone1,
          Mail: item.Mail,
          Country: item.Country,
          ZipCode: item.ZipCode,
          CreatedDate: moment(item.CreatedDate).format("DD.MM.YYYY"),
          UpdatedDate: item.UpdatedDate ? moment(item.UpdatedDate).format("DD.MM.YYYY") : '',
          Deleted: item.Deleted === true ? "Silindi" : "",
          TaxNumber: item.TaxNumber,
          TaxeName: item.TaxeName,
          Addrnumber: item.Addrnumber,
          İsActive: item.İsActive
        }
        return data
      }),
    [dealerList]
  )

  return (
    <div className=''>
      <div className='content col-lg-12 m-auto'>
        <div className='card'>
          <div className='card-header d-flex justify-content-between align-items-center mb-2'>
            <div className='col-lg-10 d-flex align-items-center'>
              <h4>Bayi Listesi</h4>
            </div>
          </div>
          <div className='row ml-2 mr-2'>
            <div className='col-lg-2'>
              <label htmlFor='trackNo' className='form-label'>
                Cari Kodu / Vergi Numarası
              </label>
              <IPInput
                type='text'
                className='form-control'
                name='dealerCode'
                placeholder='Cari Kodu / Vergi Numarası'
                onChange={(e) => setState({ dealercode: String(e.target.value).trim() })}
                value={state.dealercode}
              />
            </div>
            <div className='col-lg-2'>
              <label htmlFor='trackNo' className='form-label'>
                Cari Adı
              </label>
              <IPInput
                type='text'
                className='form-control'
                name='dealerName'
                placeholder='Cari Adı'
                onChange={(e) => setState({ dealerName: String(e.target.value).trim() })}
                value={state.dealerName}
              />
            </div>
            <div className='col-lg-1 mt-5'>
              <IPButton text={'Göster'}
                type='button' className='btn btn-primary'
                onClick={() => getDealerList()} />
            </div>
          </div>
          <div className='card-body'>
            <div className='row'>
              <div className='col-lg-12'>
                <div className='row'>
                  <div className='col-sm-12'>
                    <Table columns={tableColumns} data={tableData} currentPage={0} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default componentWithContext(Index)
